import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreatePurchaseVoucherList, purchaseVouchDelete, purchaseVoucherPdf } from '../store/slices/purchase';
import { ListParties } from '../store/slices/parties';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import { FaFileExcel, FaFileDownload } from "react-icons/fa";
import { FaFilePdf } from 'react-icons/fa6';
import {toast } from 'react-hot-toast';
import {excelPurchaseVoucherDownload } from "../common/ExcelDownload"
import { API_BASE_URL, API_PATHS } from '../utils/constants/api.constants';

const PurchaseBillList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [purchaseVoucherlist, setPurchaseVoucherlist] = useState([]);
  const [listParties, setListParties] = useState([]);
  const [selectedParty, setSelectedParty] = useState(null);
   const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
    const [selectAll, setSelectAll] = useState(false);
  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Bill #', field: 'bill_no' },
    { header: 'Date', field: 'bill_date' },
    { header: 'Party', field: 'party_name' },
    { header: 'Paid Amount', field: 'paid_amount' },
    { header: 'Pending Amount', field: 'pending_amount' },
    { header: 'Amount', field: 'total_amount' },

    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      actionButtons: [
        { name: 'Edit', className: 'btn-default' },
        { name: 'Delete', className: 'btn-cancel' },
          {
                  className: 'btn-danger mt-1',
                  icon: <FaFilePdf style={{ fontSize: '15px' }} />,
          },
      ],
    },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const partyOptions = listParties.map((party) => ({
    value: party.id,
    label: party.ledger,
  }));

  // Load saved financial year and dates from localStorage
  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem("selectedFinancialYear");

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes("-")) {
      [startYear, endYear] = savedFinancialYear.split("-");
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear; // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem("savedFromDate") || `${startYear}-04-01`,
      toDate: localStorage.getItem("savedToDate") || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };

  const {
    fromDate: initialFromDate,
    toDate: initialToDate,
    minDate,
    maxDate,
    financialYear: initialFinancialYear,
  } = loadSavedDates();
  
  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [financialYear, setFinancialYear] = useState(initialFinancialYear);
  
  
  useEffect(() => {
    if (financialYear) {
      localStorage.setItem('selectedFinancialYear', financialYear);
    }
  
    const [startYear, endYear] = financialYear.split('-');
  
    // Ensure dates remain within the financial year range
    const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
    const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;
  
    setFromDate(savedFromDate);
    setToDate(savedToDate);
  
    if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
    if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
  }, [financialYear]);
  
  
  const fetchParties = async () => {
    try {
      const data = await dispatch(ListParties({ profile_id: id })).unwrap();
      setListParties(data?.data);
    } catch (error) {
      console.log('Error fetching parties:', error.message);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    if (item && item.id) {
      navigate(`/purchase/editpurchasevoucher/${item.id}`);
    } else {
      console.log('Item or item.id is undefined');
    }
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this Purchase Voucher?');
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(purchaseVouchDelete({ id: item.id , profile_id: id }))
        .unwrap()
        .then((data) => {
          setIsLoading(false);
          hindleReturn();
        })
        .catch(({ message }) => {
          setIsLoading(false);
          toast.error(message);
        });
    } else {
      console.log('Deletion canceled');
    }
  };

  const hindleReturn = () => {
    setIsLoading(true);
    dispatch(CreatePurchaseVoucherList({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setPurchaseVoucherlist(data?.data);
      })
      .catch(({ message }) => {
        setPurchaseVoucherlist([]);
        setIsLoading(false);
        console.log(message);
      });
  };

  const fetchPurchaseVoucherList = async () => {
    setIsLoading(true);
    const params = {
      profile_id: id,
      from_date: fromDate,
      to_date: toDate,
      ledger_id: selectedParty?.value || '',
    };
    // console.log(params)
    try {
      const data = await dispatch(CreatePurchaseVoucherList(params)).unwrap();
      setIsLoading(false);
      setPurchaseVoucherlist(data?.data);
    } catch (error) {
      setIsLoading(false);
      setPurchaseVoucherlist([]);
      console.log('Error fetching invoices:', error.message);
    }
  };

  useEffect(() => {
    fetchParties();
    fetchPurchaseVoucherList();
  }, [dispatch]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchPurchaseVoucherList();
  };

  const filtereditemList = purchaseVoucherlist?.filter(
    (party) =>
      party?.bill_no?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.date_added?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.party_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.billing_state?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.total_amount?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

      const handleExcelDownload = () => {
        if (!purchaseVoucherlist || purchaseVoucherlist.length === 0) {
            alert("No data available for download.");
            return;
        }
    
        const selectedInvoices = selectAll && purchaseVoucherlist.length > 0
            ? purchaseVoucherlist.map(invoice => invoice.id)
            : selectedRows;
    
        if (!selectedInvoices || selectedInvoices.length === 0) {
            alert("Please select at least one PurchaseVoucher.");
            return;
        }
    
        const selectedData = purchaseVoucherlist.filter(invoice => selectedInvoices.includes(invoice.id));
    
        if (selectedData.length === 0) {
            alert("No matching PurchaseVoucher found.");
            return;
        }
    
        try {
          excelPurchaseVoucherDownload(selectedData, "PurchaseVoucher.xlsx");
            toast.success("Downloading Excel file successfully!");
        } catch (error) {
            console.error("Error downloading Excel file:", error);
            alert("Failed to download the Excel file. Please try again.");
        }
    };

  const handlePdfDownload = async () => {
    const selectedInvoices = selectAll
      ? purchaseVoucherlist.map((invoice) => invoice.id)
      : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
      alert("Please select at least one purchase voucher.");
      return;
    }

    try {
      setIsLoading(true);

      const response = await dispatch(
        purchaseVoucherPdf({ profile_id: id, ids: selectedInvoices })
      ).unwrap();
      setIsLoading(false);

      const blob = new Blob([response], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "purchase_vouchers.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      setIsLoading(false);
      console.error("Error downloading PDF file:", error);
      alert("There was an error downloading the PDF.");
    }
  };

 // Handle date changes with validation
 const handleFromDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setFromDate(newDate);
    localStorage.setItem('savedFromDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const handleToDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setToDate(newDate);
    localStorage.setItem('savedToDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const formatFinancialYear = (startDate, endDate) => {
  return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
};

const handlePDF = (item) => {
    const data = `${API_BASE_URL}${API_PATHS.purchaseVoucherpdf}/${id}/${item.id}`;
    navigate('/Pdf-Viewer', { state: { data } });
  };
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Purchase Voucher</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Purchase</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Purchase Voucher List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn ripple btn-default" onClick={() => navigate('/purchase/addpurchasevoucher')}>
                Add Purchase Order
              </button>
               <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                                                 Export Excel <FaFileExcel/>
                                                </button>
               <button className="btn ripple btn-default ms-2" onClick={handlePdfDownload}>
                                                 Download PDF <FaFileDownload/>
                                                </button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-3">
                      <label>Customer</label>
                      <Select options={partyOptions} placeholder="--Select Customer--" value={selectedParty} onChange={setSelectedParty} />
                    </div>
                    <div className="col-md-3">
                      <label>From Date</label>
                      <input type="date" className="form-control" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate}  />
                    </div>
                    <div className="col-md-3">
                      <label>To Date</label>
                      <input type="date" className="form-control" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-3 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filtereditemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filtereditemList?.length}
                onPageChange={handlePageChange}
                handleEdit={handleEdit}
                handlePDF={handlePDF}
                handleDelete={handleDelete}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows} 
                selectAll={selectAll} 
                 setSelectAll={setSelectAll} 
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default PurchaseBillList;
